import React, { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useTranslation } from 'hooks/useTranslation'
import {
  IngredientsRoot,
  IngredientsContainer,
  CopyColumn,
  Title,
  Subtitle,
  IngredientList,
  TryButton,
  ImageWrapper,
  ImageColumn,
  SelectionWrapper,
  Label,
  RecipeOption,
  BowlIcon,
  FloatText,
  ActiveIndicator,
  ProteinSelectWrapper,
} from './Ingredients.styles'
import rawBowl from '../../../../../public/assets/home/raw-bowl-ingredients.webp'
import chickenBowl from '../../../../../public/assets/icons/brand-refresh/chicken-bowl.webp'
import beefBowl from '../../../../../public/assets/icons/brand-refresh/beef-bowl.webp'
import overlayBowl from '../../../../../public/assets/icons/brand-refresh/protein-bowl-overlay.webp'
import { Text } from 'components/Text'
import { NUTRITION_PATTIES } from 'fixtures/nutrition'
import Trans from 'next-translate/Trans'
import { Proteins } from 'models/Pet'

export const Ingredients = () => {
  const { t } = useTranslation()
  const [recipe, setRecipe] = useState('beef')

  return (
    <IngredientsRoot>
      <IngredientsContainer>
        <ImageColumn>
          <ImageWrapper className="d-only">
            <Image src={rawBowl} alt={t('home:ingredients.alt')} width={538} height={550} />
          </ImageWrapper>
        </ImageColumn>
        <CopyColumn>
          <Title>{t('home:ingredients.title')}</Title>
          <Subtitle font="display" size={{ '@initial': 'small', '@bp2': 'bodyExtraLarge' }}>
            {t('home:ingredients.subtitle')}
          </Subtitle>
          <hr className="dashed-line d-only" />
          <IngredientList className="d-only">
            <Text color="accent-black" weight="regular" align="left" size="bodyLarge">
              <Trans
                i18nKey="home:ingredients.simple-ingredients"
                components={{
                  Highlight: <Text color="primary-700" weight="semiBold" size="bodyLarge" />,
                }}
                values={{
                  ingredients:
                    recipe === 'chicken'
                      ? NUTRITION_PATTIES[Proteins.CHICKEN].ingredients
                      : NUTRITION_PATTIES[Proteins.BEEF].ingredients,
                }}
              />
            </Text>
          </IngredientList>
          <SelectionWrapper>
            <RecipeOption onClick={() => setRecipe('chicken')}>
              <ProteinSelectWrapper>
                <ActiveIndicator active={recipe === 'chicken'} />{' '}
                <BowlIcon>
                  <Image
                    width={103}
                    height={103}
                    src={chickenBowl}
                    draggable={false}
                    alt={t('home:proteins.chicken')}
                  />
                </BowlIcon>
              </ProteinSelectWrapper>
              <Text
                color="accent-black"
                size="small"
                weight={{ '@initial': 'regular', '@bp2': 'semiBold' }}
              >
                {t('home:proteins.chicken')}
              </Text>
            </RecipeOption>
            <RecipeOption onClick={() => setRecipe('beef')}>
              <ProteinSelectWrapper>
                <ActiveIndicator active={recipe === 'beef'} />
                <BowlIcon>
                  <Image draggable={false} width={103} height={103} src={beefBowl} alt={t('home:proteins.beef')} />
                </BowlIcon>
              </ProteinSelectWrapper>
              <Text
                color="accent-black"
                size="small"
                weight={{ '@initial': 'regular', '@bp2': 'semiBold' }}
              >
                {t('home:proteins.beef')}
              </Text>
            </RecipeOption>
            <Link href="/recipes" passHref>
              <RecipeOption>
                <BowlIcon>
                  <Image
                    width={103}
                    height={103}
                    src={overlayBowl}
                    alt={t('home:ingredients.all-recipes')}
                  />
                </BowlIcon>
                <FloatText underline="true" size={{ '@initial': 'caption', '@bp2': 'small' }}>
                  {t('home:ingredients.all-recipes')}
                </FloatText>
              </RecipeOption>
            </Link>
          </SelectionWrapper>
          <hr className="dashed-line m-only" />
          <Text className="m-only" color="primary-700">
            {t('home:ingredients.ingredients-label')}
          </Text>
          <hr className="dashed-line" />
          <IngredientList className="m-only">
            <Text color="accent-black" font="display" weight="regular" align="center" size="small">
              {recipe === 'chicken'
                ? NUTRITION_PATTIES[Proteins.CHICKEN].ingredients
                : NUTRITION_PATTIES[Proteins.BEEF].ingredients}
            </Text>
          </IngredientList>
          <Link href="/meal-plan" passHref>
            <TryButton className='cta'>{t('home:ingredients.cta')}</TryButton>
          </Link>
        </CopyColumn>
        <ImageWrapper className="m-only">
          <Image src={rawBowl} alt={t('home:ingredients.alt')} width={538} height={550} />
        </ImageWrapper>
      </IngredientsContainer>
    </IngredientsRoot>
  )
}
